import { render, staticRenderFns } from "./CardSublist.vue?vue&type=template&id=c458991a&"
import script from "./CardSublist.vue?vue&type=script&lang=js&"
export * from "./CardSublist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../.nvm/versions/node/v16.15.0/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VIcon,VList,VListGroup,VListItem,VListItemAction,VListItemContent,VListItemTitle})
